import { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

const StakePushGreyMultiplier: FC<IllustrationProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="StakePushGreyMultiplier"
      illustration={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={restProps?.width ?? "24"}
          height={restProps?.height ?? "24"}
          viewBox="0 0 48 48"
          fill="none"
          {...props}
        >
          <path
            d="M3.92871 11.4906C3.92871 7.5265 7.14222 4.31299 11.1063 4.31299H37.125C41.089 4.31299 44.3025 7.5265 44.3025 11.4906V28.0045C44.3025 30.2919 43.2123 32.4423 41.3672 33.7942L28.3005 43.3686C27.1316 44.2251 25.7202 44.6868 24.271 44.6868C22.8432 44.6868 21.4513 44.2385 20.2919 43.4051L6.91704 33.7914C5.04094 32.4429 3.92871 30.2737 3.92871 27.9632V11.4906Z"
            fill="black"
          />
          <path
            d="M3.92871 14.0794C3.92871 10.1154 7.14222 6.90186 11.1063 6.90186H37.125C41.089 6.90186 44.3025 10.1154 44.3025 14.0794V30.5934C44.3025 32.8807 43.2123 35.0311 41.3672 36.3831L28.3005 45.9574C27.1316 46.8139 25.7202 47.2757 24.271 47.2757C22.8432 47.2757 21.4513 46.8274 20.2919 45.994L6.91704 36.3803C5.04094 35.0318 3.92871 32.8626 3.92871 30.5521V14.0794Z"
            fill="#AEB4C9"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.1064 0.5H37.1251C43.195 0.5 48.1157 5.42068 48.1157 11.4907V28.0046C48.1157 31.5071 46.4463 34.7999 43.6211 36.8701L30.5543 46.4444C28.7316 47.78 26.5308 48.5 24.2711 48.5C22.0447 48.5 19.8744 47.8009 18.0665 46.5014L4.69161 36.8877C1.81882 34.8228 0.115723 31.5012 0.115723 27.9633V11.4907C0.115723 5.42069 5.0364 0.5 11.1064 0.5ZM11.1064 4.31308C7.14231 4.31308 3.92881 7.5266 3.92881 11.4907V27.9633C3.92881 30.2738 5.04104 32.443 6.91714 33.7915L20.292 43.4052C21.4514 44.2386 22.8433 44.6869 24.2711 44.6869C25.7203 44.6869 27.1317 44.2252 28.3006 43.3687L41.3673 33.7943C43.2124 32.4424 44.3026 30.292 44.3026 28.0046V11.4907C44.3026 7.52659 41.0891 4.31308 37.1251 4.31308H11.1064Z"
            fill="#AEB4C9"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M33.2283 39.7578L28.3005 43.3686C27.1316 44.2251 25.7202 44.6868 24.271 44.6868C22.8432 44.6868 21.4513 44.2385 20.2919 43.4051L15.0029 39.6035V19.3208H33.2283V39.7578Z"
            fill="url(#paint0_linear_8470_4023)"
            fill-opacity="0.6"
          />
          <path
            d="M32.6426 18.6388C32.6426 18.6388 32.0663 18.4465 31.2659 18.18C28.5049 17.2596 26.307 15.0618 25.3867 12.301C25.1201 11.5003 24.9278 10.924 24.9278 10.924C24.8112 10.5744 24.4839 10.3386 24.1154 10.3386C23.7468 10.3386 23.4196 10.5745 23.303 10.9241C23.303 10.9241 23.1108 11.5004 22.8443 12.3007C21.9239 15.0617 19.7261 17.2596 16.9652 18.1799C16.1646 18.4465 15.5883 18.6388 15.5883 18.6388C15.2387 18.7554 15.0029 19.0826 15.0029 19.4512C15.0029 19.8198 15.2388 20.147 15.5884 20.2636C15.5884 20.2636 16.1647 20.4558 16.965 20.7223C19.726 21.6427 21.9239 23.8405 22.8442 26.6013C23.1108 27.4019 23.303 27.9782 23.303 27.9782C23.4196 28.3278 23.7468 28.5637 24.1154 28.5637C24.4839 28.5637 24.8113 28.3279 24.9279 27.9783C24.9279 27.9783 25.1202 27.402 25.3867 26.6016C26.307 23.8406 28.5049 21.6427 31.2657 20.7224C32.0663 20.4558 32.6426 20.2636 32.6426 20.2636C32.9922 20.147 33.228 19.8198 33.228 19.4512C33.228 19.0826 32.9922 18.7554 32.6426 18.6388Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_8470_4023"
              x1="24.1156"
              y1="19.3208"
              x2="24.1156"
              y2="44.6868"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#A9FFEE" />
              <stop offset="1" stopColor="white" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};

export default StakePushGreyMultiplier;
